//变量部分
//地图及图层

import { xor, xorBy } from "lodash";
//const process = require("process");
//因为创建图层后会挂载到map上，因此这里如果可以通过id在map里查询到的，就应该只保存一个id进来，而不应该把整个图层对象或者矢量数据对象加载进来，减弱系统越用越卡的问题。
var map,
  mapClone,
  markDrawGraphicLayer,
  markDrawGraphicLayer2,
  markDrawGraphicLayerObj,
  terrainElevationTree,
  shpInfoListTree,
  terrainModifyTree,
  terrainModifyClipId,
  labelListTree;
var overviewMap;
var checkedIds = []; //默认勾选的树节点id数组。
var tileLayerIds = []; //默认DOM瓦片id数组
var osgbTilesetLayerIds = []; //tileset瓦片id数组
var ptDataList = [];

var plotItemLayer = null;
var plotCloneItemLayer = null;
var terrainClip = null;
var terrainClipGraphic = null;
var tilesetLayer = null;
var lngLatPointFormatLength = 8;

//判断地图是否加载完
var loading_map_finish = false;
var loading_map_times = 0;

//常量部分
var default_markIconColor = "#ffd700"; //默认标记图标颜色
var default_markTextColor = "#fffef9"; //默认标记文本颜色

var rainEffect,
  snowEffect,
  snowCover,
  fogEffect,
  nightVisionEffect,
  msaaSamples,
  brightnessEffect;

var projectBaseUrl = process.env.VUE_APP_PROJECT_BASE_URL;
var modelBasePort = process.env.VUE_APP_MODEL_BASE_PORT; //服务器模型端口
var demBasePort = process.env.VUE_APP_DEM_BASE_PORT; //服务器dem端口
var domBasePort = process.env.VUE_APP_DOM_BASE_PORT; //服务器dom端口
var localResourcesPath = process.env.VUE_APP_LOCAL_RESOURCES_PATH; //服务器资源路径
export default {
  map,
  mapClone,
  markDrawGraphicLayer,
  markDrawGraphicLayer2, //新增标记时创建的矢量图层绑定的事件处理跟编辑标记时创建的矢量图层绑定的事件处理会有差别，为避免冲突，所以另外再创建一个全局变量来保存。到后面再看怎么优化。
  markDrawGraphicLayerObj,
  terrainElevationTree, //设置这个变量的原因是因为地图加载时加载的图层到后续高程弹窗列表里要能灵活控制【根据已创建的图层id取消和隐藏】，因为只是保存树结构数据，而没有保存图层本身，因此影响应该不大。
  terrainModifyTree,
  terrainModifyClipId,
  shpInfoListTree,
  labelListTree,
  loading_map_finish,
  loading_map_times,
  checkedIds,
  tileLayerIds,
  osgbTilesetLayerIds,
  ptDataList,
  default_markIconColor,
  default_markTextColor,

  overviewMap,

  rainEffect,
  snowEffect,
  snowCover,
  fogEffect,
  nightVisionEffect,
  msaaSamples,
  projectBaseUrl,
  modelBasePort,
  demBasePort,
  domBasePort,
  localResourcesPath,
  plotItemLayer,
  plotCloneItemLayer,
  terrainClip,
  terrainClipGraphic,
  tilesetLayer,
  brightnessEffect,
  lngLatPointFormatLength,
};
